import * as React from "react";
import * as style from "./Fun.style";
import { IKImage } from "imagekitio-react";
import { hooks } from "../../../utility";
import { Link } from "react-router-dom";
import krakenImage from "../../../../public/assets/kraken-on-water.jpeg";

const Fun: React.FC = () => {
  const display = hooks.useDisplayContext();
  return (
    <div className={style.component}>
      <div className={style.imageContainer}>
        <IKImage
          className={style.image}
          alt="rehoboth bay booze cruise"
          path="/paradise-grill-pontoon-boat.png"
        />
      </div>
      <div className={style.content}>
        {!display.isMobile && (
          <IKImage
            className={style.logo}
            alt="The Octolounge Logo"
            path="/logos/octolounge-logo-only.png"
          />
        )}
        <div className={style.title}>Fun begins here.</div>
        <div className={style.subTitle}>Choose your Boat!!</div>
        <div className={style.boatSection}>
          <div className={style.boatCard}>
            <div className={style.boatName}>The Octolounge</div>
            <div className={style.boatDetails}>
              The only private boat charter experience in the area that allows
              you to enjoy everything the Rehoboth Bay has to offer. It's your
              own fully customizable day on the water with an experienced
              Captain. Whether you'd like to spend the day hanging out at the
              Sandbar with the locals or bar-hop from Irish Eyes in Lewes to
              Paradise Grill in Long Neck, the Octolounge gives you the
              flexibility to choose your perfect itinerary.
            </div>
          </div>
          <div className={style.boatCard}>
            <div className={style.boatName}>The Kraken</div>
            <div className={style.boatDetails}>
              The Kraken is the only double-decker pontoon boat on the bay
              featuring a slide and is built for an unforgettable day on the
              water. Our Captains will take you to some of the bay's most
              popular swimming spots and deeper sandbars where you can enjoy the
              water like never before. Designed as the ultimate party platform,
              it's perfect for enjoying music, friends, and nonstop fun. An
              attached inflatable dock creates the ideal space to relax, float,
              and soak it all in.
            </div>
          </div>
        </div>
        <div className={style.buttons}>
          <Link to="/offers" className={style.explore}>
            <div>Explore</div>
          </Link>
          <a
            className={style.link}
            rel="noreferrer"
            href="https://fareharbor.com/embeds/book/theoctolounge/?full-items=yes"
          >
            <div className={style.bookNow}>Book Now</div>
          </a>
        </div>
      </div>
    </div>
  );
};

Fun.displayName = "Fun";
export { Fun };
